module.exports = __webpack_public_path__ + "img/swift-flex-white.27b99829.png";